export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70f25bffada79f5c17e7f1f8b562fbebbefeefc6f9&name=pushAdClickData!'